export default __webpack_public_path__ + "static/stop1-e2c17c4ce86f6998bd4ad4511823e664.png";